// countModule.js

const countModule = {
  namespaced: true, // 네임스페이스 활성화
  
  state: {
    counter: 0
  },
  getters: {
    doubleCounter(state) {
      return state.counter * 2;
    }
  },
  mutations: {
    increment(state) {
      state.counter++;
    },
    decrement(state) {
      state.counter--;
    },
    increaseBy(state, payload) {
      state.counter += payload.amount;
    }
  },
  actions: {
    asyncIncrement({ commit }) {
        commit('increment');
    }
  }
};

 export default countModule ;

